import React from 'react';
import { Button, Typography } from '@growthaxl/web-foundation';
import type { ApprovalCardBlock } from '../../types';

export interface ApprovalCardBlockViewProps {
  block: ApprovalCardBlock;
  onOptionSelect?: (option: string, hilRequestId?: string) => void;
}

export function ApprovalCardBlockView({ block, onOptionSelect }: ApprovalCardBlockViewProps): React.ReactElement {
  return (
    <div data-testid="block-approval_card" className="border border-border-default rounded-8 px-3 py-2.5 flex flex-col gap-2 bg-surface-secondary/40">
      <Typography variant="subtitle2" color="primary">
        {block.question}
      </Typography>
      <div className="flex flex-wrap gap-2">
        {block.options.map((option, i) => (
          <Button
            key={i}
            variant={option.toLowerCase() === 'reject' ? 'ghost' : 'secondary'}
            size="xs"
            onClick={() => onOptionSelect?.(option, block.hil_request_id)}
          >
            {option}
          </Button>
        ))}
      </div>
    </div>
  );
}
